import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SendIcon from '@mui/icons-material/Send';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTypedSelector } from 'hooks';
import Image from 'next/image';
import React from 'react';
import { API } from '_helpers';
import CustomInput from '../../../customInput';

const ContactUsForm: React.FC<IProps<IContactUs>> = ({ data }) => {
  const contact = useTypedSelector((state) => state.auth);
  return (
    <Box sx={{ py: 12 }}>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              <Typography
                component="h2"
                color="text.primary"
                variant="h2"
                gutterBottom
              >
                {data.title}
              </Typography>
              <Typography color="text.secondary" gutterBottom>
                {data.description}
              </Typography>
            </Stack>
            <Stack spacing={3} sx={{ py: 4 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <CustomInput
                    name="name"
                    placeholder={data.form.name}
                    icon={<PersonOutlineIcon />}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomInput
                    name="email"
                    placeholder={data.form.email}
                    icon={<AlternateEmailIcon />}
                  />
                </Grid>
              </Grid>
              <CustomInput
                placeholder={data.form.message}
                name="message"
                rows={4}
              />
              <Box>
                <Button
                  variant="contained"
                  component="a"
                  href={`mailto:uptodatedevelopers@gmail.com?subject=From Website - ${contact.name}&body=${contact.message}`}
                  disableElevation
                  startIcon={<SendIcon />}
                >
                  {data.button}
                </Button>
              </Box>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack
              alignItems="center"
              justifyContent="center"
              sx={{
                width: '80%',
                height: '100%',
                m: 'auto',
              }}
            >
              <Image
                alt={data.media.alternativeText}
                src={`${API}${data.media.url}`}
                width={data.media.width}
                height={data.media.height}
                priority
              />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactUsForm;
